/* flow */
import React, { PureComponent } from 'react'
import labels from './labels'
import type { Lang, Mode } from './App'
import {capitalize} from './globals'

type Props = {
  date: string,
  lang: Lang,
  width: number,
  mode: Mode
}

export default class LegendHeader extends PureComponent<Props> {

  render() {
    const { lang, width , mode} = this.props
    if(capitalize(mode) === 'Pte') {    
    return (
      <thead className="ac-legend__header">
        <tr>
          <th>{this.props.date}</th>
          <th className="right aligned ">{labels[lang]['val' + capitalize(mode)]}</th>
          <th className="right aligned ">{labels[lang]['change' + capitalize(mode)]}</th>
          {width >= 768 && <th className="right aligned fixed-width">{labels[lang]['m' + capitalize(mode)]}</th>}
          {width >= 768 && <th className="right aligned fixed-width">{labels[lang]['y' + capitalize(mode)]}</th>}
          {width >= 1200 && <th className="right aligned fixed-width">{labels[lang]['y3' + capitalize(mode)]}</th>}
          {width >= 1200 && <th className="right aligned fixed-width">{labels[lang]['max' + capitalize(mode)]}</th>}
        </tr>
      </thead>
    )
    }else  {
      return (
        <thead className="ac-legend__header">
          <tr>
            <th>{this.props.date}</th>
            <th className="right aligned fixed-width">{labels[lang]['val' + capitalize(mode)]}</th>
            <th className="right aligned fixed-width">{labels[lang]['change']}</th>
            {width >= 768 && <th className="right aligned fixed-width">{labels[lang]['m' + capitalize(mode)]}</th>}
            {width >= 768 && <th className="right aligned fixed-width">{labels[lang]['y' + capitalize(mode)]}</th>}
            {width >= 1200 && <th className="right aligned fixed-width">{labels[lang]['y3' + capitalize(mode)]}</th>}
            {width >= 1200 && <th className="right aligned fixed-width">{labels[lang]['y5' + capitalize(mode)]}</th>}
          </tr>
        </thead>
      )      
    }
  }
}



// WEBPACK FOOTER //
// ./src/LegendHeader.js